import { render } from "./OsdLueckentext.vue?vue&type=template&id=6a8fb71e&scoped=true"
import script from "./OsdLueckentext.vue?vue&type=script&lang=js"
export * from "./OsdLueckentext.vue?vue&type=script&lang=js"

import "./OsdLueckentext.vue?vue&type=style&index=0&id=6a8fb71e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8fb71e"]])

export default __exports__